import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Calendar, Heart } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function VefatEdenler() {
  const [obituaries, setObituaries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchObituaries();
  }, []);

  const fetchObituaries = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/obituaries`);
      const data = await response.json();
      setObituaries(data);
    } catch (error) {
      toast.error('Vefat edenler yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white flex items-center justify-center">
        <div className="text-xl text-amber-800">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 fade-in">
          <h1 className="text-4xl sm:text-5xl font-bold text-amber-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
            Vefat Edenler
          </h1>
          <p className="text-lg text-amber-700">
            Rahmetle anıyoruz
          </p>
        </div>

        {obituaries.length === 0 ? (
          <Card className="border-2 border-amber-200 bg-white">
            <CardContent className="p-12 text-center">
              <p className="text-lg text-amber-700">Henüz kayıt bulunmuyor</p>
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {obituaries.map((person) => (
              <Card key={person.id} className="card-hover border-2 border-amber-200 bg-white" data-testid={`obituary-${person.id}`}>
                <CardContent className="p-6">
                  <div className="text-center">
                    {person.image_url ? (
                      <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden border-4 border-amber-300 shadow-lg">
                        <img 
                          src={person.image_url} 
                          alt={`${person.first_name} ${person.last_name}`}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ) : (
                      <div className="w-32 h-32 mx-auto mb-4 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center text-white text-4xl font-bold border-4 border-amber-300 shadow-lg">
                        {person.first_name.charAt(0)}{person.last_name.charAt(0)}
                      </div>
                    )}
                    <h3 className="text-2xl font-bold text-amber-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
                      {person.first_name} {person.last_name}
                    </h3>
                    <div className="space-y-2 text-amber-700">
                      <div className="flex items-center justify-center gap-2">
                        <Calendar className="w-4 h-4" />
                        <span className="text-sm">Doğum: {formatDate(person.birth_date)}</span>
                      </div>
                      <div className="flex items-center justify-center gap-2">
                        <Calendar className="w-4 h-4" />
                        <span className="text-sm">Vefat: {formatDate(person.death_date)}</span>
                      </div>
                    </div>
                    <div className="mt-6 pt-4 border-t border-amber-200 space-y-3">
                      <p className="text-amber-800 italic">"Mekânı cennet olsun"</p>
                      <Link to={`/vefat-edenler/${person.id}`}>
                        <Button variant="outline" className="border-amber-300 text-amber-900 hover:bg-amber-50">
                          <Heart className="w-4 h-4 mr-2" />
                          Taziye Mesajı Yaz
                        </Button>
                      </Link>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
